// extracted by mini-css-extract-plugin
module.exports = {"box":"box___2ROy1","box_title":"box_title___3mQFS","keys_box":"keys_box___248bJ","key_item":"key_item___TAK0X"};